/**
 * NotificationStack - Displays notifications as snackbars
 */

import { FC } from 'react';
import { Snackbar, Alert, Button, Stack } from '@mui/material';
import { useNotifications, useApp } from '../../store';

export const NotificationStack: FC = () => {
  const notifications = useNotifications();
  const { dismissNotification } = useApp();

  if (notifications.length === 0) {
    return null;
  }

  // Show the first notification (FIFO)
  const notification = notifications[0];

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    dismissNotification(notification.id);
  };

  return (
    <Snackbar
      open={true}
      autoHideDuration={notification.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{ maxWidth: 400 }}
    >
      <Alert
        severity={notification.severity}
        onClose={handleClose}
        variant="filled"
        sx={{ width: '100%' }}
        action={
          notification.action ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  notification.action?.onClick();
                  dismissNotification(notification.id);
                }}
                aria-label={notification.action.label}
              >
                {notification.action.label}
              </Button>
            </Stack>
          ) : undefined
        }
        role="alert"
        aria-live={notification.severity === 'error' ? 'assertive' : 'polite'}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};
